import React from 'react';

import { useDeviceDetails } from '@apis/asset-data-service/queries/use-device-details';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@packages/fenrir/components';

import { AssetIpTableRowSkeleton } from './asset-ip-table-row-skeleton/asset-ip-table-skeleton';
import { AssetIpTableRows } from './asset-ip-table-rows/asset-ip-table-rows';
import { useAssetIpTableColumns } from './use-asset-ip-table-columns/use-asset-ip-table-columns';

export interface AssetIpTableProps {
  assetId: string;
}

export const AssetIpTable: React.FC<AssetIpTableProps> = ({ assetId }) => {
  const { data: deviceDetails, isPending } = useDeviceDetails(assetId);

  const columns = useAssetIpTableColumns();

  return (
    <Table sx={{ maxWidth: 'fit-content' }}>
      <TableHead>
        <TableRow>
          {columns.map((column) => (
            <TableCell
              key={column}
              sx={{
                pl: 0,
                pr: 4,
                py: 0,
                pb: 1,
                borderBottom: 'none',
                color: 'text.secondary',
                typography: 'metaLabel',
              }}
            >
              {column}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {isPending ? (
          <AssetIpTableRowSkeleton />
        ) : (
          <AssetIpTableRows
            networkInterfaces={deviceDetails?.networkInterfaces}
          />
        )}
      </TableBody>
    </Table>
  );
};
